import axios, { AxiosHeaders } from "axios";
import { trackCorrelationId } from "@/state/telemetryStore";
import { appEnv } from "@/config/env";

export const httpClient = axios.create({
  baseURL: appEnv.apiBaseUrl,
  withCredentials: false
});

httpClient.interceptors.request.use((config) => {
  const correlationId =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `cid-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const headers = AxiosHeaders.from(config.headers);
  headers.set("X-Correlation-Id", correlationId);
  config.headers = headers;
  trackCorrelationId(correlationId, config.url ?? "unknown");

  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const headers = AxiosHeaders.from(error?.config?.headers ?? {});
    const correlationId = headers.get("X-Correlation-Id") ?? "unknown-correlation-id";
    // Provide lightweight console logging for ops troubleshooting.
    // Intentionally avoid user-facing side effects here.
    console.error("API request failed", {
      correlationId,
      url: error?.config?.url,
      status: error?.response?.status,
      payload: error?.response?.data
    });
    return Promise.reject(error);
  }
);

